import { render } from "./MyQuotes.vue?vue&type=template&id=47b5e9be&scoped=true"
import script from "./MyQuotes.vue?vue&type=script&lang=js"
export * from "./MyQuotes.vue?vue&type=script&lang=js"

import "./MyQuotes.vue?vue&type=style&index=0&id=47b5e9be&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b5e9be"]])

export default __exports__